import { defineStore } from 'pinia';
import { MessageState } from './types';
// 消息中心
const useMessageStore = defineStore('message', {
  state: (): MessageState => ({
    // 消息列表
    messageList: [],
    // 当前选择的消息类型
    currentMsgType: 0,
    todoConfig: {
      // 近三天
      nearThreeDayNumber: 0,
      // 逾期
      overdueNumber: 0,
      // 今天
      todayNumber: 0,
      // 未完成待办
      undoneNumber: 0,
    },
    flowConfig: {
      // 待我审批
      awaitingApprovalCount: 0,
    },
  }),

  getters: {},

  actions: {
    setMessageList(data?: Array<Recordable>) {
      this.messageList = data ?? [];
    },
    // 根据消息id更新未读数
    setUnReadMsgById(msgTypeId: number, val: number) {
      this.messageList.forEach((item: any) => {
        if (item.msgTypeId === msgTypeId) {
          item.unReadMessageCount = val;
        }
      });
    },
    setDefaultTodoConfig(data: any) {
      if (!data) return;
      this.todoConfig = data;
    },
    setCurrentMsgType(msgTypeId?: number) {
      this.currentMsgType = msgTypeId ?? 0;
    },
    setDefaultFlowConfig(data: any) {
      if (!data) return;
      this.flowConfig = data;
    },
  },
});

export default useMessageStore;
